import { Component, OnInit, Input } from '@angular/core';
import { Transaccion } from '@shared/models/stock/Transaccion';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TipoMovimientoStock } from '@shared/enums/tipoMovimientoStock';
import { AerovaleDetalleComponent } from '@despacho/aerovale-detalle/aerovale-detalle.component';
import { AerovalesService } from '@despacho/aerovales.service';
import { AerovaleDetalle } from '@shared/models/despacho/AerovaleDetalle';
import { NgxSpinnerService } from 'ngx-spinner';
import { TransaccionesService } from '../../transacciones.service';
import { VisorComprobanteCargamentoComponent } from '@shared/visor-comprobante-cargamento/visor-comprobante-cargamento.component';
import { MessageService } from '@shell/message.service';
import { ModalConfirmComponent } from '@shared/generic-modals/modal-confirm.component';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { AnulacionDTO } from '@shared/models/stock/AnulacionDTO';
import { UsuarioService } from '@account/usuario.service';
import { Usuario } from '@shared/models/despacho/Usuario';
import { Recepcion } from '@shared/models/stock/Recepcion';
import { TipoComprobanteMovimiento } from '@shared/enums/TipoComprobanteMovimiento';
import { RecepcionCombustibleContenedor } from '@shared/models/stock/RecepcionCombustibleContenedor';
import { TipoProducto } from '@shared/enums/tipoProducto';

@Component({
  selector: 'app-movimiento-detalle',
  templateUrl: './movimiento-detalle.component.html',
  styleUrls: ['./movimiento-detalle.component.css']
})
export class MovimientoDetalleComponent implements OnInit {
  
  TipoUsuario = TipoUsuario;
  TipoMovimientoStock = TipoMovimientoStock;
  TipoComprobanteMovimiento = TipoComprobanteMovimiento;
  
  aerovaleDetalle: AerovaleDetalle;
  remitoCargamento: Recepcion;
  obteniendoAerovale: boolean;
  anulandoMovimiento: boolean = false;

  @Input() transaccionSeleccionada: Transaccion; // es el movimiento que me seleccionan desde tablero
  obteniendoDetalleMovimiento: boolean = false;
  movimientoSeleccionado: Transaccion;
  constructor(private authService: AuthService, 
    public modal: NgbActiveModal, public activeModal: NgbModal, private aerovaleServie: AerovalesService, 
    private transaccionService: TransaccionesService,  private spinner: NgxSpinnerService, private messageService: MessageService, private usuarioService: UsuarioService) { }

  ngOnInit() {
    this.obtenerTransaccionPorId();
  }


  // form

  mostrarAerovale() {
    this.modal.close();
    const modalRef = this.activeModal.open(AerovaleDetalleComponent, { size: "lg", centered: true })
    modalRef.componentInstance.aerovaleDetalle = this.aerovaleDetalle;  
  }

  mostrarComprobanteCargamento(i: number) {
    this.modal.close();
    const modalRef = this.activeModal.open(VisorComprobanteCargamentoComponent, { size: "lg", centered: true })
    modalRef.componentInstance.movimiento = this.movimientoSeleccionado;
    modalRef.componentInstance.comp = i;

    const datosMuestra: RecepcionCombustibleContenedor[] = [];
    
    if (this.isMovimientoRecepcion && !this.isMovimientoRecepcionDucto) {
      this.remitoCargamento.recepciones.forEach(r => {
        const dato = datosMuestra.find(d => d.codigoProducto == r.codigoProducto);
        if(!dato){
          datosMuestra.push(r);
        }
      })
      modalRef.componentInstance.recepcion = this.remitoCargamento;
      modalRef.componentInstance.datosMuestra = datosMuestra;
    }
  }

  obtenerTipoMovimiento(tipo: number) {
    return TipoMovimientoStock[tipo];
  }

  esRebombeo(m: Transaccion): boolean {
    return (m.tipoTransaccion === 4);
  }

  puedoAnularMovimiento():boolean{
    return !this.movimientoSeleccionado.titulo.includes('Anulacion') && this.movimientoSeleccionado.tipoTransaccion!=0 && this.movimientoSeleccionado.tipoTransaccion != 5 && this.movimientoSeleccionado.tipoTransaccion!=9;
  }

  // llamadas al service

  obtenerTransaccionPorId() {
    this.handleSpinner(true);
    this.transaccionService.getTransaccionPorId(this.transaccionSeleccionada.id)
      .subscribe(result => {
        this.movimientoSeleccionado = result;
        this.movimientoSeleccionado.movimientos.sort((a, b) => a.cantidad - b.cantidad);
        if (this.movimientoSeleccionado.tipoTransaccion == 4 && this.movimientoSeleccionado.movimientos.length > 1) {
          this.movimientoSeleccionado.movimientos.splice(0, 1);
        }
        this.movimientoSeleccionado.tipoTransaccion == 0 || this.movimientoSeleccionado.tipoTransaccion == 5 ? this.obtenerAerovale(this.movimientoSeleccionado.comprobante.aerovaleId) : this.aerovaleDetalle = null;
        this.isMovimientoRecepcion && !this.isMovimientoRecepcionDucto ? this.obtenerRemitoCargamento(result.comprobante.id) : this.handleSpinner(false);
      })
  }

  obtenerRemitoCargamento(remitoId: string) {
    this.transaccionService.getRemitoCargamentoPorId(remitoId).subscribe(r => {
      this.remitoCargamento = r;
      this.handleSpinner(false);
    }, () => {
        this.messageService.showErrorMessage("Hubo un error al obtener el recibo.")
        this.handleSpinner(false);
    })
  }

  obtenerCantidad15Recepcion(codigoTanque: string) {
    let cantidad15Mediciones = 0;
    this.remitoCargamento.recepciones.forEach(r => {
      if(r.codigoTanque == codigoTanque) {
        cantidad15Mediciones += r.medicionFinal.nivel;
        cantidad15Mediciones -= r.medicionPrevia.nivel;
      }
    })
    return cantidad15Mediciones;
  }

  obtenerTemperaturaRecepcion(codigoTanque: string) {
    const recepcion = this.remitoCargamento.recepciones.find(r => r.codigoTanque == codigoTanque);
    if (recepcion) return recepcion.medicionFinal.temperatura;
  }

  obtenerDensidadRecepcion(codigoTanque: string) {
    const recepcion = this.remitoCargamento.recepciones.find(r => r.codigoTanque == codigoTanque);
    if (recepcion) return recepcion.medicionFinal.densidad.toFixed(3);
  }

  obtenerAptoProducto(codigoProducto: string) {
    const recepcion = this.remitoCargamento.detalles.find(d => d.codigoProducto == codigoProducto);
    if (recepcion && !this.isMovimientoRecepcionDucto) {
      return recepcion.calidadProducto.aptoCalidad;
    }
  }

  obtenerAerovale(id: string) {
    this.obteniendoAerovale = true;
    this.aerovaleDetalle = null;
    this.aerovaleServie.getAerovalePorIdyTipo(id)
      .subscribe(result => {
        this.aerovaleDetalle = result;       
        this.obteniendoAerovale = false;
      });
  }

  anularMovimiento() {
    const modalRef = this.activeModal.open(ModalConfirmComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.mensaje = '¿Está seguro que desea anular el movimiento seleccionado?';
    modalRef.result.then(result => {
      if (result == 'Si') {
        this.anulandoMovimiento = true;
        this.transaccionService.anularMovimiento(this.transaccionSeleccionada.id)
          .subscribe(() => {
            if((this.transaccionSeleccionada.tipoTransaccion == 6 || this.transaccionSeleccionada.tipoTransaccion == 7) && (this.transaccionSeleccionada.productos[0].tipoProducto == 1 || this.transaccionSeleccionada.productos[0].tipoProducto == 3)) {
              this.anularMovimientoRecepcionCombustible()
            } else {
              this.messageService.showSuccessMessage('El movimiento fue anulado correctamente.');
              this.anulandoMovimiento = false;            
              this.modal.close(true);
            }
          }, () => {
            this.messageService.showErrorMessage('Hubo un error al anular el movimiento, por favor reintentelo.');
            this.anulandoMovimiento = false;
          })
      }

    })
  }

  handleSpinner(show: boolean) {
    show ? this.spinner.show('spinnerDetalleMovimiento') : this.spinner.hide('spinnerDetalleMovimiento');
    this.obteniendoDetalleMovimiento = show;
  }

  anularMovimientoRecepcionCombustible() {
    
    const anulacionDto: AnulacionDTO = new AnulacionDTO();
    anulacionDto.remitoId = this.movimientoSeleccionado.comprobante.id;
    const usuario = new Usuario();
    usuario.nombreCompleto = this.usuarioService.getNombresOperador();
    usuario.userName = this.usuarioService.getUsername();
    usuario.dni = this.usuarioService.getDniOperador();
    usuario.codigoUsuario = this.usuarioService.getIdUsuario();
    anulacionDto.usuario = usuario;
  
    this.transaccionService.anularMovimientoRecepcion(anulacionDto).subscribe( () =>  {
      this.messageService.showSuccessMessage('El movimiento fue anulado correctamente.');
      this.anulandoMovimiento = false;            
      this.modal.close(true);
    }, () => {
      this.messageService.showErrorMessage('Hubo un error al anular el movimiento, por favor reintentelo.');
      this.anulandoMovimiento = false;
    });
  }

  get isMovimientoRecepcion(): boolean { 
    return this.movimientoSeleccionado.tipoTransaccion === TipoMovimientoStock.Recepcion && (this.transaccionSeleccionada.productos[0].tipoProducto == TipoProducto.Aerocombustible || this.transaccionSeleccionada.productos[0].tipoProducto == TipoProducto.Combustible) ;
  }
  
  get isMovimientoRecepcionAeroespecialidad(): boolean {
    return this.movimientoSeleccionado.tipoTransaccion === TipoMovimientoStock.Recepcion && this.transaccionSeleccionada.productos[0].tipoProducto == TipoProducto.Aeroespecialidad;
  }

  get isMovimientoRecepcionDucto(): boolean {
    return this.transaccionSeleccionada.titulo.startsWith('Recepción Desde Ducto');
  }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }
}
